// providers/clio.ts
import * as Api from '@ViewModels';
import { ATTORNEY_TAG_OPTIONS } from './constants';
import { provider, providerTag, select, toggle } from './helpers';

export const clioConfig = provider(Api.IntegrationProvider.Clio, {
	displayName: 'Clio',

	main: {
		writebacks: true,
		fields: [
			toggle('loadNonClients', {
				label: 'Non-Clients',
				subtitle: 'Include non-client contacts from Clio in the sync',
			}),
			toggle('loadRelatedContacts', {
				label: 'Related Contacts',
				subtitle: 'Include related contacts from matters in the sync',
			}),
			toggle('disableCustomFieldTagPrefix', {
				label: 'Disable Custom Field Tag Prefix',
				subtitle: 'Disable the custom field label prefix for tags created from custom fields synced from Clio',
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: true,
		customDateFields: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
		providerTags: [
			providerTag('GroupPracticeArea', 'Group Practice Area'),
			{
				id: 'GroupPracticeAreaTagForRelated',
				label: 'Group Practice Area (Related)',
				settingsKey: 'groupPracticeAreaTagForRelatedEnabled',
			},
			providerTag('Relationship'),
			providerTag('MatterNumber', 'Matter Number'),
			providerTag('LastClosedMatterYear', 'Last Closed Matter Year'),
		],
		extraFields: [
			select('responsibleAttorneyTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Responsible Attorney Tag Options',
				subtitle: 'Control how responsible attorney information is tagged on contacts',
				placeholder: 'Select responsible attorney tag options',
			}),
			select('originatingAttorneyTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Originating Attorney Tag Options',
				subtitle: 'Control how originating attorney information is tagged on contacts',
				placeholder: 'Select originating attorney tag options',
			}),
		],
	},
});
